<div class="card">
  <div class="card-body">
    <div class="row">
      <div class="col-lg-12">
        <h5 class="border-bottom pb-2 mb-2">{{ 'broadcasting.Upload Documents for Broadcasting' | translate}}</h5>
      </div>

      <div class="col-md-12 d-flex justify-content-start mt-4 px-3">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group mb-0">
              <label>{{'header.assesmentyear' | translate }}<span class="required-field">*</span></label>
              <select [(ngModel)]="selectedYearMonth['ay']" class="form-control custom-selectbox">
                <option *ngFor="let year of yearDropDownList" value="{{year}}">{{year}}</option>
              </select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group mb-0 ">
              <label>{{'dataSubs.month' | translate }}<span class="required-field">*</span></label>
              <select [(ngModel)]="selectedYearMonth['month']" class="form-control custom-selectbox">
                <option value="" [disabled]="true">{{'monthmaps.selcecttag' | translate}}</option>
                <option *ngFor="let month of monthList" [value]="month.key">
                  {{'monthmaps.' + month['value'] | translate}}</option>
              </select>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-0">
              <label class="text-nowrap">{{ 'broadcasting.Enter Subject of the document'  | translate}}<span class="required-field">*</span></label><br>
              <input type="text" [(ngModel)]="docSubject" class="w-100 text-input
              ">

            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-0">
              <label>{{ 'broadcasting.Select File' | translate}}<span class="required-field">*</span></label>
              <input type="file" [(ngModel)]="selectedFiles" (change)="filechoosen($event)" name="file"
                class="form-control pointer">
            </div>
          </div>
          <div class="col-6">
            <label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
            <div class="d-flex mt-2">
              <button *ngIf="selectedFiles" class="btn btn-danger mr-3" (click)="removechosenfile()">{{'submitdata.Remove' | translate}}</button>
              <button class="btn btn-info pointer mr-3" (click)="previewFileUpload()" type="submit">{{ 'broadcasting.Preview' | translate}}</button>
              <button class="btn btn-info pointer mr-3" (click)="uploadBCdoc()" type="submit">{{'broadcasting.Upload' | translate}}</button>
            </div>
          </div>

          <!-- <div class="col-auto d-flex justify-content-end align-items-end mt-2 w-100">
            <div class="px-1">
              <button class="btn btn-info pointer" (click)="previewFileUpload()" type="submit">{{ 'broadcasting.Preview' | translate}}</button>

            </div>
            <div class="px-1">
              <button class="btn btn-info pointer" (click)="uploadBCdoc()" type="submit">{{'broadcasting.Upload' | translate}}</button>
            </div>
          </div> -->
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table table-sm" *ngIf="broadcastData">
        <thead>
          <tr class="text-center  ">
            <th scope="col">{{'trigManage.sno' | translate}}</th>
            <th scope="col" style="width: 65%;">Subject</th>
            <th scope="col">{{ 'broadcasting.Upload Date' | translate }}</th>
            <th scope="col">{{'dataSubs.download' | translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td>{{broadcastData.description}}</td>
            <td>{{formatTmStmp(broadcastData.insertTs)}}</td>
            <td><span class="text-center mt-2">
                <button class="btn btn-sm btn-info" (click)="downloadUpldedDoc(broadcastData.fileUUID)" type="submit"
                  [disabled]="!showDownloadbtn">{{'dataSubs.download' | translate}}</button>
              </span></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- <ng-template #submitModal>
  <div class="modal-header d-flex justify-content-center p-4">
    <h3 class="modal-title text-white">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Upload Confirmation</h3>
      <button type="button" (click)="CloseWindowModal()" class="close" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <h5>Are you sure you want to upload the document for broadcasting</h5>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-success" (click)="submitPopupModal()">Confirm</button>
      <button type="button" class="btn btn-danger" (click)="CloseWindowModal()" >Cancel</button>
    </div>
</ng-template> -->
